import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Anexos } from "../models/anexos.model";

@Injectable()
export class AnexosService extends BaseService<Anexos> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getAll(id:number = null): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/" + id , { headers: this.headers });
  }
  public getAttachById(attach_id:number = null): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/attach/" + attach_id , { headers: this.headers });
  }
  public uploadFile(attach_id: number,newData:any, file: File): Observable<any> {
    const formData: FormData = new FormData();
    if (file){
      formData.append('import_file', file, file?.name);
    }
    formData.append('newData',  JSON.stringify(newData));
    if(attach_id != 0){
      return this.http.post<any>(this.baseUrl + "/" + attach_id, formData);
    }
    else{
      return this.http.post<any>(this.baseUrl, formData);
    }
  }

  public downloadFile(attach_id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + attach_id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }
  public getPathModule(): string {
    return '/reuniao/anexos';
  }
}